import PropTypes from 'prop-types';
import React from 'react';

import _ from 'lodash';
import cx from 'classnames';

import styles from './styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';

const plural = (value, suffix) => {
    const localizedEngage = localizedStrings.pages.engage;
    const localizedCommons = localizedStrings.commons;
    const localizedKeywords = localizedStrings.keywords

    switch(suffix){
      case "users":
        return value === 1 ? `${value} ${localizedCommons.user}` : `${value} ${localizedCommons.users}`;
      case "countries":
        return value === 1 ? `${value} ${localizedEngage.description_card.country}` : `${value} ${localizedEngage.description_card.countries}`;
      case "assets":
        return value === 1 ? <span className={styles.assets}>{`${value} ${localizedKeywords.asset}`}</span> : <span className={styles.assets}>{`${value} ${localizedKeywords.assets}`}</span>;
      case "live_users":
        return value === 1 ? ` ${value} ${localizedEngage.description_card.live_user}` : ` ${value} ${localizedEngage.description_card.live_users}`;
    }
}
const formatTimeSpent = (seconds) => {
  seconds = Number(seconds);
  var h = Math.floor(seconds / 3600);
  var m = Math.floor(seconds % 3600 / 60);
  var s = Math.floor(seconds % 3600 % 60);

  var hours = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
  var minutes = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
  var seconds = ""
  if (hours <= 0) {
    seconds = s > 0 ? s + (s == 1 ? " sec" : " secs ") : "";
  }

  return hours + minutes + seconds;
}

class NudgesView extends React.Component {
  constructor(props) {
    super(props);

    this.localizedEngage = localizedStrings.pages.engage;
    this.localizedCommons = localizedStrings.commons;
  }

  componentDidMount() {
    this.props.fetchNudges();
  }

  render() {
    return (
      <div className={styles.nudges}>
        {this.props.loading &&
          <div className={styles.loading}>{`${this.localizedCommons.loading.loading}...`}</div>
        }
        {this.renderNudges()}
      </div>
    )
  }

  renderNudges() {
    if (this.props.loading) {
      return false;
    }

    const empty = _.size(this.props.nudges) == 0;
    if (empty) {
      return <div className={cx(styles.nudge)}>
        <div className={styles.icon}>
          <i /><i /><i />
        </div>
        <div className={styles.heading}></div>
        <p className={styles.description}>{this.localizedEngage.description_card.sub_text}</p>
      </div>
    }

    return this.props.nudges.map(nudge => {
      if (nudge.type === 'time_spent') {
        return (
          <TimeBasedNudgeCard
            nudge={nudge}
            active={nudge.id === this.props.selected}
            onClick={this.props.onChange}
          />
        );
      } else if (nudge.type === 'live_users') {
        return (
          <LiveUsersBasedNudgeCard
            nudge={nudge}
            active={nudge.id === this.props.selected}
            onClick={this.props.onChange}
            totalRecords={this.props.totalRecords}
          />
        );
      } else if (nudge.type === 'user_activity' && nudge.timespent > 0) {
        return (
          <UserActivityBasedNudgeCard
            nudge={nudge}
            active={nudge.id === this.props.selected}
            onClick={this.props.onChange}
          />
        );
      }
    });
  }
}

class TimeBasedNudgeCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}
    this.handleNudgeClick = this.handleNudgeClick.bind(this);
    this.localizedEngage = localizedStrings.pages.engage;
    this.localizedCommons = localizedStrings.commons;
    this.localizedKeywords = localizedStrings.keywords;

  }

  renderDescription() {
    const id = _.get(this.props.nudge, 'id');
    const users = _.get(this.props.nudge, 'users', 0);
    const countries = _.get(this.props.nudge, 'countries', 0);
    const timespent = _.get(this.props.nudge, 'timespent', 0);
    const assets = _.get(this.props.nudge, 'assets', 0);

    var timeSpan = '24hrs';
    switch (id) {
      case 'last_24_hours':
        timeSpan = `24hrs`;
        break;

      case 'last_week':
        timeSpan = `1 week`;
        break;

      case 'last_month':
        timeSpan = `month`;
        break;
    }
    return localizedStrings.formatString(this.localizedEngage.description_card.comment,{
      users : plural(users, "users"),
      countries : plural(countries,"countries"),
      timespent : formatTimeSpent(timespent),
      assets : plural(assets,"assets"),
    })
  }

    renderHeading() {
    const id = _.get(this.props.nudge, 'id');
    const localizedFilters = this.localizedEngage.description_card.filters

    var timeSpan = '24hrs';
    switch (id) {
      case 'last_24_hours':
        timeSpan = localizedFilters.hrs;
        break;

      case 'last_week':
        timeSpan = localizedFilters.week;
        break;

      case 'last_month':
        timeSpan = localizedFilters.month;
        break;
    }

    return `${this.localizedEngage.description_card.last} ${timeSpan}:`;
  }

  handleNudgeClick() {
    this.props.onClick(this.props.nudge);
  }

  render() {
    return (
      <div className={cx(styles.nudge, {
        [styles.active]: this.props.active
      })} onClick={this.handleNudgeClick}>
        <div className={styles.icon}>
          <i /><i /><i />
        </div>
        <div className={styles.heading}>{this.renderHeading()}</div>
        <p className={styles.description}>{this.renderDescription()}</p>
      </div>
    )
  }
}

class LiveUsersBasedNudgeCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}
    this.handleNudgeClick = this.handleNudgeClick.bind(this);
    this.localizedEngage = localizedStrings.pages.engage;
    this.localizedCommons = localizedStrings.commons;
    this.localizedKeywords = localizedStrings.keywords;
    
  }

  renderDescription() {
    const id = _.get(this.props.nudge, 'id');
    const users = _.get(this.props.nudge, 'users') ||0;
    const localizedEngageCard = this.localizedEngage.description_card;

    const end_user = users === 1 ? localizedEngageCard.is :localizedEngageCard.are;

    return localizedStrings.formatString(localizedEngageCard.live_users_text,{
      end_user: end_user,
      live_users : plural(users, "live_users")
    })
  }

  handleNudgeClick() {
    this.props.onClick(this.props.nudge);
  }

  render() {
    const localizedEngageCard = this.localizedEngage.description_card;
    return (
      <div className={cx(styles.nudge, {
        [styles.active]: this.props.active
      })} onClick={this.handleNudgeClick}>
        <div className={styles.icon}>
          <i /><i /><i />
        </div>
        <div className={styles.heading}>{`${localizedEngageCard.live_users}:`}</div>
        <p className={styles.description}>{this.renderDescription()}</p>
      </div>
    )
  }
}

class UserActivityBasedNudgeCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}
    this.handleNudgeClick = this.handleNudgeClick.bind(this);
    this.localizedEngage = localizedStrings.pages.engage;
    this.localizedCommons = localizedStrings.commons;
  }

  renderDescription() {
    const id = _.get(this.props.nudge, 'id');
    const name = `${_.get(this.props.nudge, 'chatUser.firstName')} ${_.get(this.props.nudge, 'chatUser.lastName') || ''}`;
    const timespent = _.get(this.props.nudge, 'timespent');
    const localizedCard = this.localizedEngage.description_card;

    return localizedStrings.formatString(localizedCard.spent_over,{name : name, timespent: formatTimeSpent(timespent)})
  }

  handleNudgeClick() {
    this.props.onClick(this.props.nudge);
  }

  render() {
    const localizedCard = this.localizedEngage.description_card;
    return (
      <div className={cx(styles.nudge, {
        [styles.active]: this.props.active
      })} onClick={this.handleNudgeClick}>
        <div className={styles.icon}>
          <i /><i /><i />
        </div>
        <div className={styles.heading}>{`${localizedCard.user_activity}:`}</div>
        <p className={styles.description}>{this.renderDescription()}</p>
      </div>
    )
  }
}

export default NudgesView;